import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSticker"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.468 2 12.8957 2.20157 13.2073 2.51309L21.4869 10.7927C21.7984 11.1043 22 11.532 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.5902 11.9828C15.8381 12.3007 11.6994 8.16167 12.0172 3.40983C12.0283 3.24336 12.2284 3.17282 12.3463 3.2908L20.7092 11.6536C20.8272 11.7716 20.7566 11.9717 20.5902 11.9828Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSticker;
